import { useConfigureStore, usePartnerDiscount } from '@finn/ua-vehicle';

export const usePartnerDiscountTotalSavings = ({
  closedUserGroupId,
}: {
  closedUserGroupId?: string;
}) => {
  const partnerDiscount = usePartnerDiscount({ closedUserGroupId });
  const {
    vehicle,
    term,
    downPayment: isDownPayment,
    kilometerPackage,
  } = useConfigureStore();

  if (!partnerDiscount) {
    return undefined;
  }

  const priceObject = isDownPayment
    ? vehicle?.downpayment_prices
    : vehicle?.price;

  const monthlyPrice = Math.floor(
    (priceObject?.available_price_list[`b2c_${term}`] || 0) +
      (priceObject?.[`extra_${kilometerPackage}`] || 0)
  );

  return term * monthlyPrice * partnerDiscount;
};
